import React from 'react';

const TONES = {
  neutral: 'bg-white/[0.04] border-white/[0.08] text-gray-300',
  accent: 'bg-sky-400/[0.08] border-sky-400/25 text-sky-300',
  success: 'bg-[#B0FC38]/[0.08] border-[#B0FC38]/25 text-[#B0FC38]',
  warning: 'bg-yellow-500/[0.08] border-yellow-500/25 text-yellow-300',
  danger: 'bg-red-500/[0.08] border-red-500/25 text-red-300',
  muted: 'bg-white/[0.02] border-white/[0.04] text-gray-500',
  // Waiting on someone outside NexSav (the "Awaiting reply" pill).
  waiting: 'bg-violet-400/[0.08] border-violet-400/25 text-violet-300',
};

export default function StatusBadge({ tone = 'neutral', children, icon: Icon, className = '' }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-[11px] font-medium tracking-wide whitespace-nowrap ${TONES[tone] || TONES.neutral} ${className}`}
    >
      {Icon && <Icon className="w-3 h-3" />}
      {children}
    </span>
  );
}

export function RoleBadge({ role }) {
  if (role === 'nexsav_admin') {
    return <StatusBadge tone="accent">Admin</StatusBadge>;
  }
  if (role === 'ops') {
    return <StatusBadge tone="warning">Ops</StatusBadge>;
  }
  if (role === 'media') {
    return <StatusBadge tone="success">Media</StatusBadge>;
  }
  return <StatusBadge tone="neutral">Client</StatusBadge>;
}

export function ActiveBadge({ active }) {
  if (active) return <StatusBadge tone="success">Active</StatusBadge>;
  return <StatusBadge tone="muted">Disabled</StatusBadge>;
}

// Account status for the Users lists: an active account whose person has never
// chosen a password is "Invited" (or "Invite expired" once the link lapses).
export function UserStatusBadge({ user }) {
  if (!user?.isActive) return <StatusBadge tone="muted">Disabled</StatusBadge>;
  if (user.passwordSet === false) {
    const link = user.passwordLink;
    if (!link || link.expired) return <StatusBadge tone="warning">Invite expired</StatusBadge>;
    return <StatusBadge tone="warning">Invited</StatusBadge>;
  }
  return <StatusBadge tone="success">Active</StatusBadge>;
}

export function userStatusKey(user) {
  if (!user?.isActive) return 'disabled';
  if (user.passwordSet === false) return 'invited';
  return 'active';
}
